import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Button } from 'reactstrap'
import { SelectWithLabel } from 'components/Form'
import Nixi1Spinner from 'components/Nixi1Spinner'

const TimerSelectorUI = (props) => {
  const {
    className, label, unitOptions, time, unit,
    onClick, disabled, onChangeTime, onChangeUnitTime
  } = props

  const unitValue = unitOptions.find(el => el.value === unit) || unitOptions[0]

  return (
    <div className={`timer-selector ${className ? className : ''}`}>
      {label && <label className='timer-selector__label'>{label}</label>}
      <div className='timer-selector__selector'>
        <input
          className='timer-selector__time'
          type='text'
          value={time || 0}
          onChange={event => onChangeTime({ unit: unitValue.value, time: event.target.value })}
        />

        <SelectWithLabel
          classNameWrapper='timer-selector__unit'
          placeholder={I18n.t('dashboard_select')}
          options={unitOptions}
          value={unitValue}
          selectedValues={unitValue}
          onChange={data => onChangeUnitTime({ time: time || 0, unit: data.value })}
        />

        {
          onClick ? (
            <Button
              type='submit'
              color='btn btn-secondary'
              className='timer-selector__btn-save'
              onClick={onClick}
              disabled={disabled}
            >
              {
                !disabled
                  ? I18n.t('dashboard_save')
                  : <Nixi1Spinner height='15px' width='15px' />
              }
            </Button>
          ) : null
        }
      </div>
    </div>
  )
}

export default TimerSelectorUI
